// extracted by mini-css-extract-plugin
export default {"mainContainer":"Main_mainContainer__8memN","logo":"Main_logo__8f2It"};